export default "__VITE_ASSET__4n22zwVs__"